import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { PlatformTelegram } from '@smmof/entity';
import { AdOrderItemSettingsInterface } from '@smmof/interface';
import { AdOrderDraftUpsertDto, ValidateDraftResponseDto } from '@smmof/dto';

export const AdOrderDraftActions = createActionGroup({
  source: 'AdOrderDraft',
  events: {
    'Load AdOrderDraft': emptyProps(),
    'Load AdOrderDraft Success': props<{ draft: AdOrderDraftUpsertDto }>(),
    'Load AdOrderDraft Failure': props<{ error: any }>(),

    'Create AdOrderDraft': emptyProps(),
    'Create AdOrderDraft Failure': props<{ error: any }>(),

    'Add Platform To AdOrderDraft': props<{ platform: PlatformTelegram }>(),
    'Remove Platform From AdOrderDraft': props<{ platformId: number }>(),

    'Update Order Item Settings': props<{ platformId: number; settings: AdOrderItemSettingsInterface }>(),

    'Clear AdOrderDraft': emptyProps(),

    'Save AdOrderDraft': emptyProps(),
    'Save AdOrderDraft Failure': props<{ error: any }>(),

    'Submit AdOrderDraft': emptyProps(),
    'Submit AdOrderDraft Success': props<{ orderId: number }>(),
    'Submit AdOrderDraft Failure': props<{ error: any }>(),

    'Update AdPublication': props<{ adPublication: any }>(),

    // Апсерт на бэк
    'Upsert Requested': emptyProps(),
    'Upsert Success': props<{ serverDraftId?: number; updatedAt?: string }>(),
    'Upsert Failure': props<{ error: any }>(),

    // Refresh платформ в черновике
    'Refresh Platforms Requested': props<{ platformIds?: number[] }>(),
    'Refresh Platforms Success': props<{ platforms: PlatformTelegram[] }>(),
    'Refresh Platforms Failure': props<{ error: any }>(),

    // Валидация черновика
    'Validate Requested': emptyProps(),
    'Validate Success': props<{ result: ValidateDraftResponseDto }>(),
    'Validate Failure': props<{ error: any }>(),
  },
});


